import { RoutesEnum } from '@/routes/Routes.enum.ts';
import { useUserContext } from '@/utils/providers/userContext/useUserContext';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useNavigate } from 'react-router-dom';

import { useApiClient } from '../api/util/useApiClient.util.ts';
import CONFIG from '../config/config.ts';

interface Return {
  cleanUserState: () => Promise<void>;
}

export const useCleanUserState = (): Return => {
  const { restDevelopmentApi } = useApiClient();
  const { user } = useUserContext();
  const navigate = useNavigate();

  const { mutateAsync } = useMutation<void, AxiosError>({
    mutationFn: async () => {
      const email = user?.email || CONFIG.USER_EMAIL;
      if (!email) {
        throw new Error('User email is not available');
      }
      await restDevelopmentApi.cleanUserState(email, true);
      navigate(RoutesEnum.ROOT);
    },
    mutationKey: ['useCleanUserState'],
  });

  return {
    cleanUserState: mutateAsync,
  };
};
